import Axios from "axios";
export const baseURL = process.env.REACT_APP_API_URL 
Axios.defaults.baseURL = baseURL;
export default Axios;